module.exports = __webpack_public_path__ + "img/shade_quote_wht.52ff0ede.svg";